import React from 'react';
import QCStatusToggle from '@pluto/qc-status-toggle';
import {TimespanCategory} from '@pluto/rest';
import {OnMouseDivEvent, QcJobStatuses} from '@pluto/@types';
import {Button} from '@material-ui/core';
import {Item} from 'VideoAudioQC/QCMedia/Redux/QCMediaActions';
import {curry} from 'ramda';
import {QCReportMarker} from '../../Timeline/TimelineTypes';
import ListContainer, {OnButtonClick, OnEditMarker} from './List/ListContainer';

import './QCReport.scss';

type OnClickOutsideList = () => void;

interface QCReportProps {
    item: Item;
    status: QcJobStatuses;
    handlePassed: () => void;
    handleFailed: () => void;
    resetStatus: () => void;
    markers: QCReportMarker[];
    selectedMarkerId: string;
    noteTypes: TimespanCategory[];
    onMarkerClick: () => void;
    onCreateMarker: () => void;
    onEditMarkerIn: OnButtonClick;
    onEditMarkerOut: OnButtonClick;
    onGoToMarkerStartClick: OnButtonClick;
    onGoToMarkerEndClick: OnButtonClick;
    onDeleteMarker: OnButtonClick;
    onEditMarker: OnEditMarker;
    onClickOutsideList: OnClickOutsideList;
    jobDeliveryDate: string;
}

export const onClickOnContainer = curry(
    (onClickOutsideList: OnClickOutsideList, event: OnMouseDivEvent) => {
        event.stopPropagation();

        onClickOutsideList();
    }
);

export default function QCReport(props: QCReportProps) {
    const {
        item,
        status,
        markers,
        selectedMarkerId,
        noteTypes,
        onCreateMarker,
        onMarkerClick,
        onEditMarkerIn,
        onEditMarkerOut,
        onGoToMarkerStartClick,
        onGoToMarkerEndClick,
        handlePassed,
        handleFailed,
        resetStatus,
        onDeleteMarker,
        onEditMarker,
        onClickOutsideList,
        jobDeliveryDate,
    } = props;

    const {frameRate, dropFrame, duration} = item.video;
    const qcStatus = status;

    const handleClickOutsideList = onClickOnContainer(onClickOutsideList);

    return (
        <div
            className="qc-report-root"
            aria-hidden="true"
            onClick={handleClickOutsideList}
        >
            <div
                className="button-container"
                aria-hidden="true"
                onClick={handleClickOutsideList}
            >
                {!jobDeliveryDate ? (
                    <QCStatusToggle
                        onPass={handlePassed}
                        onFail={handleFailed}
                        onReset={resetStatus}
                        status={qcStatus}
                    />
                ) : (
                    <div className="qc-report-root__qc-passed">QC Passed</div>
                )}
                <Button
                    onClick={onCreateMarker}
                    variant="outlined"
                    color="primary"
                    size="small"
                    className="create-note"
                    disabled={Boolean(jobDeliveryDate)}
                >
                    Add Note
                </Button>
            </div>
            <ListContainer
                jobDeliveryDate={jobDeliveryDate}
                markers={markers}
                noteTypes={noteTypes}
                selectedMarkerId={selectedMarkerId}
                frameRate={frameRate}
                dropFrame={dropFrame}
                duration={duration}
                onMarkerClick={onMarkerClick}
                onDeleteClick={onDeleteMarker}
                onGoToStartClick={onGoToMarkerStartClick}
                onGoToEndClick={onGoToMarkerEndClick}
                onEditMarkerIn={onEditMarkerIn}
                onEditMarkerOut={onEditMarkerOut}
                onEditMarker={onEditMarker}
            />
        </div>
    );
}
